import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Images from 'Assets/Images'
import ContractInfo from '../contractInfo'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: 20
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));

export default function CenteredGrid({metamask, config}) {
    // console.log(metamask.isSigned)
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={8}>
                    {/*<Paper className={classes.paper}>*/}
                        <img style={{
                            marginLeft: 15
                        }} src={Images.description} alt=""/>
                    {/*</Paper>*/}
                </Grid>
                <Grid item xs={4}>
                    <Paper className={classes.paper}>
                        {/*<ContractInfo metamask={metamask}/>*/}
                        {metamask.isSigned && <ContractInfo metamask={metamask} config={config}/>}
                    </Paper>
                </Grid>

            </Grid>
        </div>
    );
}
